import { getIsFeatureEnabled } from 'helpers/feature-flags';
import { type RequestResult } from 'interfaces/api/client';
import { FeatureNames } from 'services/api/feature-control/interfaces';
import { type IApiGreeting } from 'store/entities/greetings/interfaces';

import { greetingsConfigurationApi } from './configuration-api/greetings/adapter';
import { legacyGreetingsApi } from './legacy-greetings/adapter';

/**
 * Public surface every greetings adapter (legacy v2, ConfAPI v3.6) must expose.
 *
 * Sagas call methods on this interface via `getGreetingsApi()` so they don't
 * need to branch on the API version that is currently active.
 */
export interface GreetingsApiSurface {
  fetchAll(): Promise<RequestResult<IApiGreeting[]>>;
  fetch(id: string): Promise<RequestResult<IApiGreeting>>;
  create(greeting: IApiGreeting): Promise<RequestResult<IApiGreeting>>;
  update(greeting: Partial<IApiGreeting>): Promise<RequestResult<IApiGreeting>>;
  remove(greetingId: string): Promise<RequestResult<void>>;
}

/**
 * Returns the greetings API surface backing the greetings sagas.
 *
 * When `FeatureNames.GreetingsConfApiEnabled` is enabled, the new Configuration API
 * v3.6 adapter is returned. Otherwise the legacy v2 adapter is used. Both expose the
 * same `{ fetchAll, fetch, create, update, remove }` shape so saga code does not
 * need to branch on the flag.
 */
export function getGreetingsApi(): GreetingsApiSurface {
  return getIsFeatureEnabled(FeatureNames.GreetingsConfApiEnabled) ? greetingsConfigurationApi : legacyGreetingsApi;
}
